import type {
  Block,
  ParagraphData,
  TextPart,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";

import "./paragraphIndented.css";


export default function ParagraphIndentedView({
  block,
}: {
  block: Block;
}) {
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-paragraph-indented">
      {data.textParts.map((part: TextPart, i: number) => {
        if (part.type === "text") {
          return <span key={i}>{part.value}</span>;
        }

        return (
          <RefLink
            key={i}
            targetId={part.targetId}
            label={part.label}
            className="pdf-ref-link text-primary"
          />
        );
      })}
    </div>
  );
}
